import { PropsWithChildren } from 'react';

export const ProfileCard: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className='bg-white'>
      <div className='py-6 px-32'>{children}</div>
    </div>
  );
};
